import * as S from "./Grid.style";
import { useMemo, useRef, useState } from "react";
import {
  ColDef,
  SelectionChangedEvent,
  SizeColumnsToContentStrategy,
  SizeColumnsToFitGridStrategy,
  SizeColumnsToFitProvidedWidthStrategy,
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { Pagignation } from "../../containers/Grid/Pagination";
import { Loading } from "../../atoms/Loading";

interface GridProps {
  width?: number;
  height?: any;
  paging?: boolean;
  rowData?: any[];
  gridTitle?: string;
  pagingShow?: boolean;
  columnDefs?: ColDef[];
  rowSelection?: "single" | "multiple";
  defaultPageSize?: number;
  onGridReady?: (event: any) => void;
  onSelectionChanged?: (event: SelectionChangedEvent) => void;
  onContextMenu?: (event: React.MouseEvent, target: any) => void;
  onCellClicked?: (row: any) => void;
  loading?: boolean;
  gridOptions?: any;
}

const defaultColDef: ColDef = {
  cellStyle: {
    display: "flex",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  headerClass: "custom-header",
};

export const Grid = ({
  height,
  paging = true,
  rowData,
  gridTitle,
  columnDefs,
  pagingShow = true,
  rowSelection,
  defaultPageSize = 10,
  onGridReady,
  onSelectionChanged,
  onCellClicked,
  loading = false,
  gridOptions,
}: GridProps) => {
  const gridRef = useRef<AgGridReact>(null);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const autoSizeStrategy = useMemo<
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy
  >(() => {
    return {
      type: "fitGridWidth",
      defaultMinWidth: 40,
    };
  }, []);
  const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newSize = parseInt(e.target.value, 10);
    if (gridRef.current && gridRef.current.api) {
      setPageSize(newSize);
    }
  };

  return (
    <S.GridBox $pagingShow={pagingShow} $height={height}>
      {gridTitle && <S.GridTit>{gridTitle}</S.GridTit>}
      <div className="ag-theme-quartz">
        <S.Grid $height={height}>
          <AgGridReact
            loading={loading}
            ref={gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            pagination={paging}
            headerHeight={
              gridOptions?.headerHeight ? gridOptions.headerHeight : 40
            }
            rowSelection={rowSelection}
            defaultColDef={defaultColDef}
            // autoSizeStrategy={autoSizeStrategy}
            paginationPageSize={pageSize}
            onSelectionChanged={onSelectionChanged}
            overlayNoRowsTemplate="조회 결과가 없습니다"
            suppressPaginationPanel={paging}
            rowMultiSelectWithClick={rowSelection === "multiple"}
            onGridReady={(event) => {
              if (onGridReady) {
                onGridReady(event);
              }
            }}
            onCellClicked={onCellClicked}
            loadingOverlayComponent={Loading}
            gridOptions={gridOptions} // 그리드 옵션 전달
          />
        </S.Grid>
      </div>
      {paging && (
        <Pagignation
          total={rowData?.length ?? 0}
          gridRef={gridRef}
          pageSize={pageSize}
          onPageSizeChange={handlePageSizeChange}
        />
      )}
    </S.GridBox>
  );
};
